import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutIntro from './components/AboutIntro';
import FeatureGrid from './components/FeatureGrid';

export default function About() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <AboutIntro />
        <FeatureGrid />
      </main>
      <Footer />
    </div>
  );
}